module.exports = __webpack_public_path__ + "img/illustration.c7d6db96.png";